import React from 'react'
import ClickAddImg from '../../../assets/images/information/click-to-add.png'
import EditSectionImg from '../../../assets/images/information/edit-section.png'

const InfoDoorWindow = () => {
  return (
    <div>
        <div className='content-text'>
            <span>Active Wall – </span>Make sure the active wall is selected to being adding the components to your building. Components will be added on the currently active wall. <br /><br /><span>Adding Components - </span>To add a door, window, or frame out, click the “+Add” button.
        </div>
        <div className='mt-3 mb-4'>
            <img src={process.env.REACT_APP_BASE_URL+ClickAddImg} className='general-img' alt='click to add'/>
        </div>
        <div className='content-text pt-2'>
            <span>Editing/Removing Components - </span>Click the “Pencil Icon” placed on the top right of the component. It will open an EDIT box for further options and customization of the component.
        </div>
        <div className='mt-3 mb-4'>
            <img src={process.env.REACT_APP_BASE_URL+EditSectionImg} className='general-img' alt='edit section'/>
        </div>
        <div className='content-text pt-2'>
            <span>Placement – </span>Drag & Set the components according to your requirements on desktop, and double-tap to position them on mobile devices.
        </div>
    </div>
  )
}

export default InfoDoorWindow